<cmps-dialog>
    <cmps-dialog-body>
        <div class="cmps-cdk-d-flex cmps-cdk-align-items-center">
            <div class="cmps-cdk-font-bold">
                {{ _i18n.__SIDE_BY_SIDE_IN_PROGRESS | translate }}
            </div>
            <div
                class="cmps-cdk-border-r-width-1px cmps-cdk-border-r-solid cmps-cdk-border-l-width-1px cmps-cdk-border-l-solid cmps-cdk-mx-0dot5 cmps-cdk-w-1px"
            >
                &nbsp;
            </div>
            <div>
                <button
                    class="cmps-icon-button--no-bg"
                    cmpsIconButton
                    [cmpsTooltipTrigger]="_i18n.__END_SIDE_BY_SIDE | translate"
                    placement="bottom-center"
                    (click)="_service.end()"
                >
                    <cmps-icon
                        class="cmps-cdk-bg-color-red-100 cmps-cdk-fill-white"
                        svgIcon="stop"
                    ></cmps-icon>
                </button>
            </div>
            <div
                class="cmps-cdk-border-r-width-1px cmps-cdk-border-r-solid cmps-cdk-border-l-width-1px cmps-cdk-border-l-solid cmps-cdk-mx-0dot5 cmps-cdk-w-1px"
                *ngIf="_service.buttons?.length > 0"
            >
                &nbsp;
            </div>
            <ng-container *ngFor="let b of _service.buttons">
                <ng-container *ngTemplateOutlet="b"></ng-container>
            </ng-container>
        </div>
    </cmps-dialog-body>
</cmps-dialog>
